import styled from 'styled-components';
import { Select, Space } from 'antd';

/**
 * BatchDetailModal 내부의 인라인 스타일을 styled-components 로 추출.
 * 리뷰 피드백 — 신규 도메인 컴포넌트는 styles.ts 분리가 컨벤션.
 *
 * generic 컴포넌트(`Select<T>`)는 styled() wrap 시 generic 시그니처가 소실되므로
 * `as typeof Select` 캐스팅으로 보존해 호출처에서 `<StyledStoreSelect<number>` 형태로 사용 가능.
 */

/**
 * 메인 모달 컨텐츠 / 롤백·검증 Card 내부의 vertical Space — width 100% 강제.
 * 기존 `<Space style={{ width: '100%' }}>` 패턴 3곳을 일괄 추출.
 */
export const StyledFullWidthSpace = styled(Space)`
  width: 100%;
` as typeof Space;

/** scope 별 추가 입력 옆의 라벨 (예: "대상 브랜드 ID:") — 폼 라벨 톤. */
export const StyledScopeLabel = styled.span`
  font-size: 13px;
`;

/**
 * 롤백 scope=byStoreId 일 때 표시되는 브랜드 ID Select — 검색 + 라벨 길이
 * 확보를 위해 최소 너비 명시. generic (`<number>`) 보존.
 */
export const StyledStoreSelect = styled(Select)`
  min-width: 220px;
` as typeof Select;

/**
 * 롤백 scope=byOrderItemIds 일 때의 multi-select — Space 안에서 가로 폭 채움.
 * generic (`<string[]>`) 보존.
 */
export const StyledOrderItemSelect = styled(Select)`
  width: 100%;
` as typeof Select;

/**
 * verify 결과의 mismatch 항목 raw JSON dump — 운영 디버깅용.
 * (향후 antd Table 로 정리 검토 — 별도 티켓)
 */
export const StyledMismatchDump = styled.pre`
  font-size: 12px;
  max-height: 200px;
  overflow: auto;
`;

/** verify 결과의 월별 합계 표 상단 라벨 — block 정렬로 표와 위/아래 여백 분리. */
export const StyledMonthlySummaryHeader = styled.b`
  display: block;
  margin: 8px 0;
`;
